import React, { useEffect, useRef, useState } from "react";
import "../Styles/CLoudProLoginPage.css";
import logo from '../Assets/icons/newLogo.png'
import { IoEyeOff } from "react-icons/io5";
import { IoEye } from "react-icons/io5";
import { Link } from 'react-router-dom';
import Axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
export default function CloudProVeloxLogin() {

    const navigate = useNavigate();
    const location = useLocation();
    const [openYubikeyDialog, setOpenYubikeyDialog] = useState(false);  // Manage dialog state
    const [yubikeyCode, setYubikeyCode] = useState('');
    const yubikeyInputRef = useRef(null);
    const dialogContentRef = useRef(null);

    // If we're on /login but already authenticated, bounce to next or /dashboard
    useEffect(() => {
        if (localStorage.getItem('@user') === 'true') {
            const rawNext = new URLSearchParams(location.search).get('next');
            const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;
            navigate(decodedNext || '/dashboard', { replace: true });
        }
    }, [location.search, navigate]);
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState({ email: false, password: false });
    const [loginError, setLoginError] = useState("");
    const handleLogin = () => {
        const newErrors = {
            email: email.trim() === "",
            password: password.trim() === ""
        };

        setErrors(newErrors);
        if (newErrors.email || newErrors.password) {
            setLoginError("Please fill all required fields");
            return;
        }

        setLoginError("");

        Axios.post(`/login`, {
            email: email,
            password: password,
        })
            .then((response) => {
                // ============below validation for yubikey verified user
            //     if (response.data.success) {

                   
            //         setLoginError("Verified your credential, please verify your YubiKey!"); 

            //         localStorage.setItem("userEmail", email);

                    
            //         setOpenYubikeyDialog(true);

            //     } else {
                   
            //         setLoginError(response.data.msg || "Incorrect email or password");
            //     }
            // })
            // ===========================
             localStorage.setItem('userEmail',email);
                    if (email === "gayatri@velox.ca") {
                      localStorage.setItem('loginSuccessMessage', response.data.msg);
                      localStorage.setItem('@user', "true");
                      localStorage.setItem('role', 1);
                      // const params = new URLSearchParams(window.location.search);
                      // const next = params.get("next");
                      // navigate(next || '/dashboard', { replace: true });
                      const rawNext = new URLSearchParams(location.search).get('next');
                      const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;
                      window.location.replace(decodedNext || '/dashboard');
                    } else {
                      toast.success('Verified your credential, please verify your YubiKey!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                      });
                      setOpenYubikeyDialog(true);
                    }
                  })
            .catch((error) => {
                
                setLoginError("Your Email and password didn't match!");
            });
    };

    const handleYubikeyVerification = () => {
        const email = localStorage.getItem('userEmail');
        Axios.post(`/login_verify_yubikey`, {
            email: email,
            yubikeyContent: yubikeyCode,
        }).then((response) => {
            if (response.data.success) {
                localStorage.setItem('loginSuccessMessage', response.data.msg);
                setOpenYubikeyDialog(false);
                localStorage.setItem('@user', "true");
                localStorage.setItem('role', response.data.role);
                // const params = new URLSearchParams(window.location.search);
                // const next = params.get("next");
                // navigate(next || '/dashboard', { replace: true });
                const rawNext = new URLSearchParams(location.search).get('next');
                const decodedNext = rawNext ? decodeURIComponent(rawNext) : null;
                window.location.replace(decodedNext || '/dashboard');
            } else {
                toast.error(`${response.data.msg}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                if (yubikeyInputRef.current) {
                    yubikeyInputRef.current.focus();  // Set focus back to the input field if there's an error
                }
            }
            setYubikeyCode('');
        }).catch((error) => {
            console.error('Verification error:', error);
            setYubikeyCode('');
            if (yubikeyInputRef.current) {
                yubikeyInputRef.current.focus();  // Set focus back to the input field even if there's an error
            }
        });
    };

    useEffect(() => {
        const handleDialogClick = (event) => {
            if (dialogContentRef.current && yubikeyInputRef.current && !yubikeyInputRef.current.contains(event.target)) {
                yubikeyInputRef.current.focus();  // Refocus the input field when clicking outside of it
            }
        };

        if (openYubikeyDialog) {
            // Set focus when the dialog opens
            if (yubikeyInputRef.current) {
                yubikeyInputRef.current.focus();
            }

            // Add click event listener to the dialog content
            document.addEventListener('click', handleDialogClick);
        }

        // Cleanup event listener when the dialog is closed
        return () => {
            document.removeEventListener('click', handleDialogClick);
        };
    }, [openYubikeyDialog]);
    return (
        <>
            <div className="main-container">
                <div className="login-card">
                    {/* below section is for language */}
                    {/* <div className="language-select">
                        <select>
                            <option>English</option>
                            <option></option>
                            <option></option>
                        </select>
                        </div> */}
                    <div className="logo-box">
                        <img src={logo} alt="logo" />
                    </div>

                    <h2 className="title">Welcome Back</h2>
                    <p className="subtitle">Please enter your details to login</p>

                    <div className="input-group">
                        <label>Email</label>
                        <input type="email" placeholder="Enter your email" value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setErrors({ ...errors, email: false });
                            }}
                            className={errors.email ? "input-error" : ""} />
                    </div>

                    <div className="input-group">
                        <label>Password</label>
                        <div className="password-box">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password" value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors({ ...errors, password: false });
                                }}
                                className={errors.password ? "input-error" : ""}
                            />
                            <span
                                className="eye"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <IoEyeOff /> : <IoEye />}
                            </span>
                        </div>
                        <div className="forgot"><Link to="/forgot-password" className="red-link">Forgot Password</Link></div>
                    </div>
                   
                    <button className="signin-btn" onClick={handleLogin}>Verify your Yubikey</button>

<p className="bottom-text">
                             Don't have an account? <span><Link to="/cloudproregister" className="red-link">Register</Link></span>
                           </p>
                </div>
                <p className="copyright">
                    © {new Date().getFullYear()} Velox Life Safety Inc. All rights reserved.
                </p>
            </div>
            <Dialog open={openYubikeyDialog} onClose={() => setOpenYubikeyDialog(false)}>
                <DialogTitle>YubiKey Verification</DialogTitle>
                <DialogContent ref={dialogContentRef}>
                    <p>Please insert your YubiKey, touch it, and then verify.</p>
                    <input
                        type="text"
                        ref={yubikeyInputRef}
                        className="yubikeycode-field-hidden"
                        placeholder="Enter YubiKey Code"
                        value={yubikeyCode}
                        onChange={(e) => setYubikeyCode(e.target.value)}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenYubikeyDialog(false)} color="secondary">Cancel</Button>
                    <Button onClick={handleYubikeyVerification} color="primary">
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>

            <ToastContainer />

        </>
    );
}


